// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;Have mercy on me, Lord, for I am weak;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;Lord, heal me, for my bones are racked.<br> </p> </div></div>";
// Exports
module.exports = code;